import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as actions from '../actions'
import { OperacionesCubicajeSiloDialogView } from '../components/OperacionessCubicajeSiloDialogView'

class OperacionesCubicajeSiloDialog extends Component {
  render () {
    const { silo } = this.props
    return (
      <OperacionesCubicajeSiloDialogView
        silo={silo}
        openDialogNuevoCubicaje={this.props.openDialogNuevoCubicaje}
        openDialogModificacionCubicaje={this.props.openDialogModificacionCubicaje}
        openDialogEliminarUltimoCubicaje={this.props.openDialogEliminarUltimoCubicaje}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    silo: state.movimientoSilos.siloOperando
  }
}
export default connect(mapStateToProps, actions)(OperacionesCubicajeSiloDialog)
